import { useTransform } from 'framer-motion'

// https://motion.dev/docs/react-scroll-animations
// https://codesandbox.io/p/sandbox/framer-motion-parallax-i9gwuc?from-embed
export function useParallax(value, distance) {
  return useTransform(value, [0, 1.8], [-distance, distance])
}
